// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"popUpStyles_wrapper__1_13H","popUp":"popUpStyles_popUp__1jAAJ","isMobile":"popUpStyles_isMobile__YIiIg"};